import React from 'react';
import { Switch } from 'react-router-dom';

import { Route, hasPermission } from '@sopranodesign/pulse-auth';

import { Subscriber } from './Pages/index';

const routes = [
  {
    name: 'Conversation',
    path: '/conversations/:id',
    component: Subscriber,
    canAccess: hasPermission('view subscribers')
  }
];

const SubscribersRouter = () => {
  return (
    <Switch>
      {routes.map((route, key) => (
        <Route
          exact={route.exact ?? true}
          public={false}
          key={key}
          path={route.path}
          canAccess={route.canAccess}
          render={props => <route.component {...props} />}
        />
      ))}
    </Switch>
  );
};

export default SubscribersRouter;
